import { render } from "./ProviderListView.vue?vue&type=template&id=896c78d8&scoped=true"
import script from "./ProviderListView.vue?vue&type=script&lang=js"
export * from "./ProviderListView.vue?vue&type=script&lang=js"

import "./ProviderListView.vue?vue&type=style&index=0&id=896c78d8&scoped=true&lang=less"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-896c78d8"]])

export default __exports__